import { useForm } from "react-hook-form";
import { useState } from "react";
import api from "../services/api";
import { taxasLabels } from "../utils/previsoes";
import { useNavigate } from "react-router-dom";

const PrevisoesForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const [textos, setTextos] = useState({});
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [taxesLabels, setTaxesLabels] = useState(taxasLabels || []);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      await api.post("/previsions/create-previsions", data);

      setMessage("Previsão salva com sucesso!");
      setMessageType("success");
    } catch (error) {
      console.error("Erro ao salvar previsão: ", error);

      setMessage("Erro ao salvar previsão. Tente novamente.");
      setMessageType("error");
    }
  };

  const handleTipoChange = (index, value) => {
    setTextos((prevTextos) => ({
      ...prevTextos,
      [index]: value === "PERCENTAGE" ? "DO" : "POR",
    }));

    const newOptions =
      value === "PERCENTAGE"
        ? [{ label: "Frete Marítimo", value: "FRETEMARITIMO" }]
        : [
            { label: "Carga", value: "ORDERLOAD" },
            { label: "Contêiner", value: "CONTAINER" },
          ];

    setTaxesLabels((prevState) =>
      prevState.map((taxa, idx) =>
        idx === index
          ? {
              ...taxa,
              options: newOptions,
            }
          : taxa
      )
    );

    setTimeout(() => {
      setValue(
        taxesLabels[index].bySelectName,
        value === "PERCENTAGE" ? "FRETEMARITIMO" : "ORDERLOAD"
      );
    }, 100);
  };

  const navigateToPrevisions = () => {
    navigate("/previsions");
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="max-w-4xl mx-auto bg-gray-50 p-6 rounded-lg shadow-md space-y-4 ml-0 mt-6">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-800">Previsões</h2>
          <button
            className="px-4 py-2 rounded-md text-white bg-orange-500 hover:bg-orange-600"
            onClick={navigateToPrevisions}
          >
            Visualizar Previsões
          </button>
        </div>
        {message && (
          <div
            className={`p-4 mb-4 rounded-lg ${
              messageType === "success"
                ? "bg-green-200 text-green-800"
                : "bg-red-200 text-red-800"
            }`}
          >
            {message}
          </div>
        )}

        <div>
          <label
            htmlFor="nomePrevisao"
            className="block text-sm font-medium text-gray-700"
          >
            Nome da previsão
          </label>
          <input
            id="nomePrevisao"
            {...register("name_previsions", { required: "Campo obrigatório" })}
            type="text"
            className="mt-1 w-full p-2 border border-gray-300 rounded"
          />
          {errors.nomePrevisao && (
            <span className="text-red-500 text-sm">
              {errors.nomePrevisao.message}
            </span>
          )}
        </div>

        {taxesLabels?.map((taxa, index) => (
          <div
            key={index}
            className="grid grid-cols-4 gap-2 items-center relative z-20"
          >
            <label className="col-span-1 text-sm uppercase font-bold text-gray-700">
              {taxa.label}
            </label>

            <select
              {...register(taxa.selectName, { required: true })}
              className="col-span-1 p-2 border border-gray-300 rounded"
              onChange={(e) => handleTipoChange(index, e.target.value)}
            >
              <option value="">Selecione uma opção</option>
              <option value="PERCENTAGE">PORCENTAGEM</option>
              <option value="FIXED">VALOR FIXO (R$)</option>
            </select>

            <div className="flex col-span-1 items-center space-x-2">
              <input
                type="number"
                step="0.01"
                {...register(taxa.inputName, { valueAsNumber: true })}
                placeholder="0"
                className="w-24 p-2 border border-gray-300 rounded"
                required
              />
              <span>{textos[index] || "POR"}</span>
              <select
                {...register(taxa.bySelectName, { required: true })}
                className="p-2 border border-gray-300 rounded"
              >
                {taxa?.options?.length > 1 && (
                  <option value="">Selecione uma opção</option>
                )}
                {taxa?.options?.map((opt, index) => {
                  return (
                    <option key={index} value={opt.value}>
                      {opt.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        ))}

        <button
          type="submit"
          className="w-full bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600"
        >
          SALVAR PREVISÃO
        </button>
      </div>
    </form>
  );
};

export default PrevisoesForm;
